import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import {
  RemoveSubscriptionAction,
  SetSubscriptionsAction,
  SubscriptionDialogAction,
  SubscriptionState,
} from '$store/subscriptions/interface';

const initialState: SubscriptionState = {
  isLoading: true,
  isFailed: false,
  subscriptions: [],
};

export const { actions, reducer } = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    subscriptionDialog(_, action: SubscriptionDialogAction) {},
    loadSubscriptions(state) {
      if (state.isFailed) {
        state.subscriptions = [];
      }

      state.isLoading = true;
      state.isFailed = false;
    },
    setSubscriptions(state, action: SetSubscriptionsAction) {
      state.subscriptions = action.payload;
      state.isLoading = false;
    },
    removeSubscription(state, action: RemoveSubscriptionAction) {
      state.subscriptions = state.subscriptions.filter(
        (item) => item.id !== action.payload,
      );
    },
    setFailed(state) {
      state.isLoading = false;
      state.isFailed = true;
    },
  },
});

export { reducer as subscriptionsReducer, actions as subscriptionsActions };

export const subscriptionsSelector = (state: RootState) => state.subscriptions;
